<template>
  <div class="infoM">
    <div class="infoTitle">
      工程信息/ENGINEERING INFORMATION
    </div>
    <div class="introduction">
      {{ engingeeringInfo }}
    </div>
    <div class="unit">
      <div
        class="unitCon"
        v-for="(item, index) in unitList"
        :key="index"
        :item-id="item.title"
      >
        <img :src="item.img" alt="" class="unitLogo" />
        <div class="unitWords">
          <div class="unitTitle">{{ item.title }}</div>
          <el-tooltip :content="item.company" placement="top" effect="dark" :disabled="!item.company">
            <div class="unitCompany">{{ item.company }}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSectionDetail } from "@/api/api";
import { mapState } from "vuex";
export default {
  props: {
    type: ""
  },
  data() {
    return {
      engingeeringInfo: "",
      unitList: [
        {
          title: "参建单位:",
          company: "",
          img: require("../assets/img/information-icon-participate@2x.png")
        },
        {
          title: "施工单位:",
          company: "",
          img: require("../assets/img/information-icon-construction@2x.png")
        },
        {
          title: "监理单位:",
          company: "",
          img: require("../assets/img/information-icon-supervisor@2x.png")
        },
        {
          title: "设计单位:",
          company: "",
          img: require("../assets/img/information-icon-participate@2x.png")
        }
      ]
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.engingeeringInfo = this.introduction || "";
      this.$set(this.unitList[0], "company", this.Participation || "");
      this.$set(this.unitList[1], "company", this.construction || "");
      this.$set(this.unitList[2], "company", this.supervisor || "");
      this.$set(this.unitList[3], "company", this.Design || "");
    },
    async SectionDetail(id) {
      if (id == "") {
        this.$set(this.unitList[1], "company", "");
        this.$set(this.unitList[2], "company", "");
        this.$set(this.unitList[3], "company", "");
      } else {
        let req = {
          sectionId: this.seIds
        };
        const sdData = await getSectionDetail(req);
        this.$set(
          this.unitList[1],
          "company",
          sdData.data.constructionOfficeList[0]
            ? sdData.data.constructionOfficeList[0].name
            : ""
        );
        this.$set(
          this.unitList[2],
          "company",
          sdData.data.controlOfficeList[0]
            ? sdData.data.controlOfficeList[0].name
            : ""
        );
        this.$set(
          this.unitList[3],
          "company",
          sdData.data.designOfficeList[0]
            ? sdData.data.designOfficeList[0].name
            : ""
        );
      }
    }
  },
  computed: mapState([
    "engineerId",
    "sectionId",
    "workAreaId",
    "introduction",
    "Participation",
    "construction",
    "supervisor",
    "Design",
    "seIds"
  ]),
  watch: {
    introduction() {
      this.getInfo();
    },
    Participation() {
      this.getInfo();
    },
    construction() {
      this.getInfo();
    },
    supervisor() {
      this.getInfo();
    },
    Design() {
      this.getInfo();
    },
    sectionId(curVal) {
      this.getInfo();
      this.SectionDetail(curVal);
    }
  }
};
</script>
<style lang="less" scoped>
.infoM {
  position: absolute;
  width: 71%;
  height: 100%;
  z-index: 100;
  .infoTitle {
    width: 50%;
    height: 24px;
    line-height: 24px;
    padding-left: 30px;
    font-weight: 700;
    font-size: 16px;
    color: #44f8ff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(../assets/img/information-title@2x.png);
  }
  .introduction {
    float: left;
    padding: 6px;
    padding-bottom: 0;
    color: #fff;
    line-height: 20px;
    font-size: 14px;
    width: 50%;
    height: 80px;
    // 多行超出隐藏
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; // 作为弹性伸缩盒子模型显示。
    -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
    -webkit-line-clamp: 4; // 显示的行
    // background-color: red;
  }
  .unit {
    // float: right;
    float: right;
    width: 48%;
    padding: 6px;
    padding-bottom: 0;
    height: 80px;
    // background-color: orange;
    .unitCon {
      float: left;
      width: 50%;
      height: 50%;
      margin-bottom: 8px;
      .unitLogo {
        float: left;
        width: 40px;
        height: 40px;
      }
      .unitWords {
        float: left;
        // width: 170px;
        width: 80%;
        margin-left: 10px;
        .unitTitle {
          font-size: 14px;
          color: #fff;
        }
        /deep/ .el-tooltip {
          display: block;
          width: 100%;
        }
        .unitCompany {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #44f8ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/info.vue